// Science page category tab switching
document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.maxx-science-tabs__btn');
  const panels = document.querySelectorAll('.maxx-science-tab-panel');

  if (!buttons.length) return;

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const target = btn.dataset.tab;

      buttons.forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-selected', 'false');
      });
      panels.forEach(function (p) {
        p.classList.remove('is-active');
        p.setAttribute('hidden', '');
      });

      btn.classList.add('is-active');
      btn.setAttribute('aria-selected', 'true');
      const panel = document.querySelector('[data-panel="' + target + '"]');
      if (panel) {
        panel.classList.add('is-active');
        panel.removeAttribute('hidden');
      }
    });
  });
});
